import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BaseUrl = process.env.REACT_APP_BASH_URL;


  export const dashboardData = createAsyncThunk(
    'dashboard/list',
    async (_, thunkAPI) => {
        try {
            // Retrieve the token from localStorage dynamically
            const token = localStorage.getItem("admin-auth-token");
            console.log('token : ' , token)
            const options = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };

            const response = await axios.get(`${BaseUrl}/admin/dashboard/data`, { headers: options });
            return response.data;
        } catch (error) {
            console.log(error.message);
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);



const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        data: [],
        status: 'idle',
        error: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(dashboardData.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(dashboardData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload.result;
            })
            .addCase(dashboardData.rejected, (state, action) => {
                state.status = 'failed';
                console.log('failed')
                state.error = action.payload;
            });


    },
});
export default dashboardSlice.reducer;
